import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

export const detectTileVisibility = (
    tilesNumber: number,
    index: number,
    selectedTilesGroupRange: number,
    selectedTileIndex: number,
): boolean => {
    let isVisible: boolean;
    if (selectedTilesGroupRange > tilesNumber - 1) {
        const range = selectedTilesGroupRange - tilesNumber;
        if (index >= range) {
            isVisible = index >= selectedTileIndex ? true : index <= range;
        } else {
            isVisible = true;
        }
    } else {
        isVisible =
            index >= selectedTileIndex && index <= selectedTilesGroupRange;
    }
    return isVisible;
};

export const setAriaHiddenAttribute = (
    tileClass: string,
    hiddenTileAttribute: string,
): void => {
    const document = getDocument();
    if (!document) return;

    const thumbSlide = document.querySelectorAll(`.${tileClass}`);
    if (thumbSlide) {
        Array.from(thumbSlide).forEach((title) => {
            if (title.hasAttribute(hiddenTileAttribute)) {
                title.setAttribute("aria-hidden", "true");
            } else {
                title.removeAttribute("aria-hidden");
            }
        });
    }
};

export const removeTabindex = (container: string): void => {
    const document = getDocument();
    if (!document) return;

    const thumbCarousel = document.querySelector(`.${container}`);
    if (thumbCarousel) {
        if (thumbCarousel.hasAttribute("tabindex")) {
            thumbCarousel.removeAttribute("tabindex");
        }
    }
};
